import panel_time_range_vue_vue_type_script_setup_true_lang_default from "./panel-time-range.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/time-picker/src/time-picker-com/panel-time-range.vue
var panel_time_range_default = panel_time_range_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { panel_time_range_default as default };
//# sourceMappingURL=panel-time-range.mjs.map